import styled from "styled-components"

type StyledProps = {
  $blockingState: boolean
}

export const CustomStateComponent = styled.div<StyledProps>`
  border-radius: 0.6rem;
  background: ${({ theme, $blockingState }) =>
    $blockingState ? theme.colors.errorBackground : theme.colors.yellowLight};
  color: ${({ theme, $blockingState }) =>
    $blockingState ? theme.colors.errorText : theme.colors.orange};
  font-weight: 700;
  border: 0.1rem solid
    ${({ theme, $blockingState }) =>
      $blockingState ? theme.colors.errorBorder : theme.colors.yellow};
  font-size: 1rem;
  display: flex;
  justify-content: center;
  padding: 0 0.5rem;
  line-height: 2rem;
  text-align: center;
`

export const RecentState = styled.div`
  width: 100%;
  cursor: pointer;
`

export const CustomStateInfo = styled.div`
  padding: 0 0.8rem;
  justify-content: center;
  display: flex;
  align-items: center;
  line-height: 2.3rem;
  word-break: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
`

export const CustomStateWrapper = styled.div`
  display: flex;
`
export const Operation = styled.div`
  display: flex;
  align-items: center;

  svg {
    height: 1rem;
    margin-right: 0.5rem;
    fill: ${({ theme }) => theme.colors.errorText};
  }
`
export const Id = styled.div`
  font-size: 1.1rem;
`

export const State = styled.div<StyledProps>`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  border: 0.1rem solid
    ${({ theme, $blockingState }) =>
      $blockingState ? theme.colors.errorBorder : theme.colors.yellow};
  background: ${({ theme, $blockingState }) =>
    $blockingState ? theme.colors.errorBackground : theme.colors.yellowLight};
  border-radius: 0.6rem;
  padding: 1rem;
  margin-bottom: 1rem;
`

export const StateHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.8rem;
`

export const StateInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 0.6rem;
  flex: 1;
  min-width: 0;
`

export const StateName = styled.span`
  font-weight: 600;
  font-size: 1.3rem;
`

export const TypeBadge = styled.span<StyledProps>`
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.1rem 0.6rem;
  border-radius: 0.3rem;
  font-size: 1rem;
  font-weight: 700;
  white-space: nowrap;
  background: ${({ theme, $blockingState }) =>
    $blockingState ? theme.colors.errorText : theme.colors.orange};
  color: ${({ theme }) => theme.colors.white};

  svg {
    width: 1rem;
    height: 1rem;
    fill: ${({ theme }) => theme.colors.white};
  }
`

export const BlockingHint = styled.span`
  font-size: 1.1rem;
  font-style: italic;
  color: ${({ theme }) => theme.colors.errorText};
  opacity: 0.8;
`

export const OperationsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
`

export const OperationTag = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.2rem 0.6rem;
  border-radius: 0.3rem;
  background: rgba(255, 255, 255, 0.4);
  border: 0.1rem solid rgba(204, 51, 51, 0.15);
  font-size: 1rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.errorText};

  svg {
    width: 0.9rem;
    height: 0.9rem;
    fill: ${({ theme }) => theme.colors.errorText};
  }
`
